import React, { useEffect, useState } from "react";
import { useStore } from "effector-react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import {
  IAccount,
  $accounts,
  queryNewAccount,
  queryAccountsChange,
  queryAccounts,
  updateAccount,
  AddChargesToAccount,
  AddOwnerTypeToAccount,
} from "../../../common/accounts2";
import { Preloader } from "../../../common/ui/Preloader/preloader";

import "../../../../node_modules/react-toastify/dist/ReactToastify.css";
import { $SiteColors } from "../../../common/config/company-atts";
import {
  getCustomUserAgent,
  getCustomUserAgentASB,
  getCustomUserAgentKrk,
} from "../../../common/customUserAgent";
toast.configure();

interface INewAccountElseCompanyBlock {
  goTo?: number; //указываем то, куда перейти после завершения или отмены добавления аккаунта(учитывается если redirectTo или redirectToOnCancel отсутствуют)
  redirectTo?: string; //переходим по этому адресу в случае успешного результата
  redirectToOnCancel?: string; //переходим по этому адресу в случае отмены
  comid: string; //идентификатор компании, по которому добавляется аккаунт
  clearDataOnCancel?: boolean;
  hideAnon?: boolean;
}

export const NewAccountElseCompanyBlock = ({
  comid,
  redirectTo = "",
  redirectToOnCancel = "",
  goTo = -1,
  clearDataOnCancel = false,
  hideAnon = true,
}: INewAccountElseCompanyBlock) => {
  console.log("CURR_COMID:", comid);
  const [values, setValues] = React.useState({
    account: "",
    password: "",
    companyId: comid,
  });

  const [newAccount, setNewAccount] = useState<IAccount | null>(null);
  const [isValid, setIsValid] = React.useState(false);
  const [disableWhileLoading, setDisableWhileLoading] = React.useState(false);

  const form = React.useRef<HTMLFormElement>(null);
  const history = useHistory();
  const { accounts } = useStore($accounts);

  React.useEffect(() => {
    if (form.current) setIsValid(form.current.checkValidity());
    console.log("VALUES:", values);
  }, [values]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    setValues({ ...values, [name]: value });
  };

  useEffect(() => {
    setValues({ ...values, companyId: comid });
  }, [comid]);

  const onAnonClicked = () => {
    window.location.href = window.location.pathname.split("/")[1];
  };

  const onCancelClicked = () => {
    history.goBack();
  };

  const handleFormSubmitAccount = (event: React.FormEvent<HTMLFormElement>) => {
    const newData = { accParams: values };
    event.preventDefault();
    setDisableWhileLoading(true);
    setIsValid(false);
    queryNewAccount({
      data: newData,
      setNewAccount,
      setDisableWhileLoading,
      setIsValid,
    })
      .then((res) => {
        return queryAccounts().then(async (res) => {
          var bar = new Promise((resolve, reject) => {
            if (res.accounts.length === 0) { resolve("@"); return } // нет ЛС — сразу завершаем
            res.accounts.forEach(async (elem, index) => {
              await updateAccount({ account: elem, accounts: res.accounts });
              await AddChargesToAccount({
                account: elem,
                accounts: res.accounts,
              });
              if (
                getCustomUserAgent() === getCustomUserAgentKrk() ||
                getCustomUserAgent() === getCustomUserAgentASB()
              ) {
                await AddOwnerTypeToAccount({
                  account: elem,
                  accounts: res.accounts,
                });
              }
              if (index === res.accounts.length - 1) resolve("@");
            });
          });
          await bar; // ждём завершения обогащения аккаунтов перед переходом
        });
      })
      .then(() => history.push(redirectTo))
      .catch((err) => {
        toast.error(err.message);
        setNewAccount(null);
        setDisableWhileLoading(false);
        setIsValid(true);
      });
  };

  return (
    <form
      className="login__form addacc__form"
      ref={form}
      onSubmit={handleFormSubmitAccount}
    >
      <input
        type="text"
        className="login__input addacc__input"
        placeholder="Введите лицевой счет"
        name="account"
        required
        id="account"
        maxLength={30}
        autoComplete="off"
        value={values.account}
        onChange={handleChange}
        disabled={disableWhileLoading}
      ></input>
      <input
        type="text"
        className="login__input addacc__input"
        placeholder="Введите пароль"
        name="password"
        required
        id="pswd"
        maxLength={30}
        autoComplete="off"
        value={values.password}
        onChange={handleChange}
        disabled={disableWhileLoading}
      ></input>
      <div className="addacc__buttons addacc__buttons_space">
        <button
          type="submit"
          className="addacc__button addacc__button_decision addacc__button_decision_submit"
          style={{ backgroundColor: $SiteColors.getState().backBtnSubmit }}
          disabled={!isValid}
        >
          {disableWhileLoading ? <Preloader small={true} /> : "Добавить"}
        </button>
        {hideAnon ? (
          <button
            type="button"
            onClick={onCancelClicked}
            style={{ color: $SiteColors.getState().backBtnSubmit }}
            className="addacc__button addacc__button_decision addacc__button_decision_cancel"
            disabled={disableWhileLoading}
          >
            Отмена
          </button>
        ) : (
          <button
            hidden={hideAnon}
            className="addacc__button addacc__button_decision addacc__button_decision_anonim"
            onClick={onAnonClicked}
            disabled={disableWhileLoading}
          >
            Анонимный вход
          </button>
        )}
      </div>
    </form>
  );
};
